const EE = {
  ibanLength: 20,
};
export { EE };
